<div id="personenAngaben">

  <div class="mb-5x pt-1">
    <div class="d-flex justify-content-between mb-3x">
      <h2>{{ 'COMMON_UI.FRAGEBOGEN.ANTRAGSTELLER.FORMULAR_TITEL' | translate }}</h2>
      <common-ui-daten-uebernahme
        (picked)="onPersonPicked($event)"
        [itemTemplate]="datenuebernahmeNatuerlichePerson"
        [items]="stammdaten?.antragsteller?.person"
        [readonly]="readonly"
        context="AntragstellerNatuerlichePerson">
      </common-ui-daten-uebernahme>
    </div>
    <common-ui-person [affectNavigationInfo]=true [(data)]="data.antragsteller" [readonly]="readonly"></common-ui-person>
  </div>

  <div class="mb-5x">
    <h2 class="mb-3x">{{ 'COMMON_UI.FRAGEBOGEN.ADRESSE.ADRESSE_TITEL' | translate }}</h2>
    <common-ui-adresserfassung
      [(auslandsadresse)]="data.auslandsadresse"
      [(inlandsadresse)]="data.inlandsadresse"
      [(postfachadresse)]="data.postfachadresse"
      [readonly]="readonly"
      [stammdatenAuslandsAdresse]="stammdaten?.antragsteller?.auslandsadressen?.array"
      [stammdatenInlandsadresse]="stammdaten?.antragsteller?.inlandsadressen?.array"
      [stammdatenPostfachadresse]="stammdaten?.antragsteller?.postfachadressen?.array">
    </common-ui-adresserfassung>
  </div>

  <div class="mb-5x">
    <h2>{{ 'COMMON_UI.FRAGEBOGEN.KOMMUNIKATIONSMITTEL.KOMMUNIKATIONSMITTEL_TITEL' | translate }}</h2>
    <common-ui-kommunikationsmittel
      [(data)]="data.kommunikationsmittel" [readonly]="readonly"
      [stammdatenInternetadressen]="stammdaten?.antragsteller?.kommunikation?.internetadressen?.array"
      [stammdatenTelefonnummern]="stammdaten?.antragsteller?.kommunikation?.telefonnummern?.array"
      maxTelefonnummern="2">
    </common-ui-kommunikationsmittel>
  </div>

  <div class="mb-5x">
    <div class="d-flex justify-content-between mb-3x">
      <h2>{{ 'COMMON_UI.FRAGEBOGEN.STEUERIDENTIFIKATION.STEUERIDENTIFIKATION_TITEL' | translate }}</h2>
      <common-ui-daten-uebernahme
        (picked)="data.steueridentifikation = $event"
        [itemTemplate]="datenuebernahmeSteueridentifikation"
        [items]="getStammdatenTemplate()" [readonly]="readonly"
        context="AntragstellerSteueridentifikation">
      </common-ui-daten-uebernahme>
    </div>
    <common-ui-steueridentifikation
      [(data)]="data.steueridentifikation"
      [readonly]="readonly">
    </common-ui-steueridentifikation>
  </div>

</div>

<ng-template #datenuebernahmeNatuerlichePerson let-item="item">
  <h4
    class="list-group-item-heading">{{item?.titel}} {{item?.vorname}} {{item?.namensvorsatz}} {{item?.namenszusatz}} {{item?.nachname}}
    <span *ngIf="item?.geburtsname">geb. {{item?.geburtsname}}</span>
  </h4>
</ng-template>

<ng-template #datenuebernahmeSteueridentifikation let-item="item">
  <p class="list-group-item-text">
    {{item?.steueridentifikationsnummer}}</p>
</ng-template>
